module.exports = __webpack_public_path__ + "static/media/id.f3c85b21.svg";